import classNames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { selectQuote, setSelectedMembershipPlanId } from '../../../../reducers/programRegistrationReducer'
import { displayWithCurrency } from '../../../../utility/currency'

import './MembershipPlanSelection.scss'

const MembershipPlanSelection = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const quote = useSelector(selectQuote)
  const selectedMembershipPlanId = useSelector(state => state.programRegistration.selectedMembershipPlanId)
  const isProcessingPayment = useSelector(state => state.programRegistration.isProcessingPayment)

  if (quote?.membership?.status !== 'purchase') {
    return null
  }

  const selectedPlanId = selectedMembershipPlanId ?? quote.membership.planId

  const handleSelectPlan = (plan) => {
    if (selectedPlanId !== plan.id) {
      dispatch(setSelectedMembershipPlanId(plan.id))
    }
  }

  return (
    <div id='MembershipPlanSelection'>
      <div className='d-flex flex-column package-card-options'>
        {quote.membership.plans.map((plan) => {
          const isSelected = selectedPlanId === plan.id

          return (
            <button
              key={plan.id}
              type='button'
              disabled={isProcessingPayment}
              onClick={() => handleSelectPlan(plan)}
              className={classNames('package-card-option', { 'package-selected': isSelected })}
            >
              <span className='package-radio'>
                {isSelected && <span className='package-radio-dot' />}
              </span>
              <span className='package-content'>
                <span className='package-header'>
                  <span className='package-name'>{t(`programs.registration.membershipPlan.tiers.${plan.tier}`)}</span>
                  <span className='package-price'>
                    {t('programs.registration.membershipPlan.perYear', { price: displayWithCurrency(plan.amount, plan.currency) })}
                  </span>
                </span>
                <span className='package-description'>
                  {t(`programs.registration.membershipPlan.descriptions.${plan.tier}`, { seats: plan.seats })}
                </span>
              </span>
            </button>
          )
        })}
      </div>
    </div>
  )
}

export default MembershipPlanSelection
